if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // Ensure variant ID is set (for products without variant selection)
      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput && variantInput.disabled) {
        console.log('⚠️ Enabling disabled variant input for bundle product');
        variantInput.disabled = false;
      }
      
      // Check if this is a bundle product by looking for bundle components
      const isBundleProduct = document.body.classList.contains('template-product') && 
                              (document.querySelector('[data-bundle-component]') || 
                               window.location.pathname.includes('bundle'));
      
      // For bundle products, try adding with bundle-compatible properties
      if (isBundleProduct || formData.get('product-id')) {
        console.log('📦 Detected potential bundle product, using bundle-compatible cart add');
        // Add bundle marker property
        formData.append('properties[_bundle]', 'true');
      }
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      
      // Log what we're submitting
      console.log('🛒 Cart Add Debug:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('❌ Cart add error:', response);
            this.handleErrorMessage(response.description);
            return;
          }

          console.log('✅ Added to cart successfully');
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error('❌ Cart add exception:', e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function openSizeSelector () {
  var sizeSelector = document.querySelector('[data-details-size]')
  console.log(sizeSelector)
  sizeSelector.open = true
}


document.addEventListener('DOMContentLoaded', () => {
  var colorChips = document.querySelectorAll('.color-chip')
  var chipName = document.getElementById('color-name')
  for (let i = 0; i < colorChips.length; i++) {
    const chip = colorChips[i];
    chip.addEventListener("mouseover", () => {
      if (chipName) chipName.innerHTML = chip.getAttribute('data-name')
    }, false);
    chip.addEventListener("mouseout", () => {
      if (chipName) chipName.innerHTML = ""
    }, false);
    
  }

  var selectSizeBtn = document.querySelector('.size-select-btn')
  if (selectSizeBtn) {
    selectSizeBtn.addEventListener('click', openSizeSelector)
  }
  

  // Initialize Swiper with proper loading check
  function initSwiper() {
    const swiperContainer = document.querySelector('.swiper-container');
    
    if (!swiperContainer) {
      console.log('Swiper container not found on this page');
      return;
    }
    
    if (typeof Swiper !== 'undefined') {
      const swiper = new Swiper('.swiper-container', {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
      console.log('Swiper initialized successfully');
    } else {
      // Wait for Swiper to load
      let attempts = 0;
      const checkSwiper = setInterval(() => {
        attempts++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          const swiper = new Swiper('.swiper-container', {
            loop: true,
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          });
          console.log('Swiper initialized after waiting');
        } else if (attempts > 50) { // Stop after 5 seconds
          clearInterval(checkSwiper);
          console.log('Swiper failed to load after 5 seconds');
        }
      }, 100);
    }
  }
  
  initSwiper();
})
